import { FunctionComponent } from 'react'

import dynamic from 'next/dynamic'

import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'

const FeatureFlagDashboard = dynamic(
  () => import('@components/FeatureFlagDashboard'),
  { ssr: false },
)

const FeatureFlagDashboardWidget: FunctionComponent = () => {
  return <FeatureFlagDashboard />
}

const widget = {
  kind: ['feature-flag-dashboard'],
  component: FeatureFlagDashboardWidget,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
